import type { Product } from "@/lib/product-utils";

export type SortOrder = "recommended" | "priceLowToHigh" | "priceHighToLow";

/**
 * Sort products by price.
 * Products without a valid price are pushed to the end, maintaining their relative order.
 *
 * @param items - Products to sort
 * @param direction - "asc" for low to high, "desc" for high to low
 * @returns New sorted array (original is not mutated)
 */
export function sortProductsByPrice(items: Product[], direction: "asc" | "desc"): Product[] {
  const multiplier = direction === "desc" ? -1 : 1;

  return [...items].sort((a, b) => {
    const priceA = typeof a.current_price === "number" ? a.current_price : null;
    const priceB = typeof b.current_price === "number" ? b.current_price : null;

    // Both null - maintain original order (stable sort)
    if (priceA === null && priceB === null) {
      return 0;
    }

    // Null prices go to the end regardless of direction
    if (priceA === null) return 1;
    if (priceB === null) return -1;

    // Compare prices with direction multiplier
    return (priceA - priceB) * multiplier;
  });
}
